import React from 'react';
import { Paragraph, Wrap } from '@leafwell/components';

import type { TeamMember as TeamMemberType } from 'types/team';
import type { BlockTeam } from 'types/block-team';

import Figure from './figure';
import HeadingBody from './heading-body';

export interface TeamMemberProps {
  person?: TeamMemberType;
  index?: number;
}

export const TeamMember: React.FC<TeamMemberProps> = ({
  person: { featuredImage, jobs, title },
  index,
}) => {
  const jobTitle = React.useMemo(() => {
    if (jobs && jobs.length > 0) {
      return jobs.map(({ name }) => name).join(', ');
    }

    return null;
  }, [jobs]);

  return (
    <article
      className={`grid md:grid-cols-1-auto gap-x-6 xl:gap-x-10 gap-y-3 lg:gap-y-6 items-start content-start ${
        index == 0 &&
        'lg:col-span-2 md:col-span-1 col-span-1 lg:row-span-2 md:row-span-1 row-span-1'
      }`}
    >
      <Figure {...featuredImage} className="md:row-span-3" />
      <Paragraph size="small" variant="medium" className="font-medium">
        {title}
      </Paragraph>
      {jobTitle && (
        <Paragraph size="small" variant="medium" className="-mt-3 lg:-mt-6">
          {jobTitle}
        </Paragraph>
      )}
    </article>
  );
};

const TeamPortraits: React.FC<BlockTeam> = ({ title, items }) => (
  <Wrap>
    {title?.length > 0 && (
      <HeadingBody
        {...{
          className: 'col-span-full text-gray-500',
          level: '6',
          title,
        }}
      />
    )}
    <div className="grid lg:grid-cols-4 gap-8 sm:grid-cols-2 grid-cols-1">
      {items.map((person, key) => {
        return <TeamMember key={key} index={key} person={person} />;
      })}
    </div>
  </Wrap>
);

export default TeamPortraits;
